import About from "./components/About ";
import Navbar from "./components/Navbar";
import Skills from "./components/Skills";
import Work from "./components/Work";
import Contact from "./components/Contact";

function App() {
  return (
    <div>
      <Navbar />
      <div className='h-[80px]' />
      <About />
      <Work />
      <Skills />
      <Contact />
    </div>
  );
}

export default App;
